import { uniqueId } from 'lodash-es';
import { GlIcon, GlLink, GlButton, GlCollapse, GlBadge, GlPopover, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
import { toNounSeriesText } from '~/lib/utils/grammar';
import HelpIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/help_icon/help_icon.vue?vue3';
import codeOwnersInfoQuery from '../../../graphql_shared/queries/code_owners_info.query.graphql';
export const i18n = {
    title: s__('CodeOwners|Code owners'),
    and: __('and'),
    errorMessage: s__('CodeOwners|An error occurred while loading code owners.'),
    manageBranchRules: __('Manage branch rules'),
    noCodeOwnersText: s__('CodeOwners|Assign users and groups as approvers for specific file changes.'),
    helpText: s__('CodeOwners|Code owners are users and groups that can approve specific file changes.'),
    learnMore: s__('CodeOwners|Learn more.'),
    showAll: s__('CodeOwners|Show all'),
    hideAll: s__('CodeOwners|Hide all')
};
export const codeOwnersHelpPath = helpPagePath('user/project/codeowners/_index.md');
export default {
    name: 'CodeOwners',
    i18n,
    codeOwnersHelpPath,
    helpPopoverId: uniqueId('help-popover-'),
    components: {
        GlIcon,
        GlLink,
        GlButton,
        GlBadge,
        GlCollapse,
        GlPopover,
        GlSprintf,
        HelpIcon
    },
    apollo: {
        project: {
            query: codeOwnersInfoQuery,
            variables () {
                return {
                    projectPath: this.projectPath,
                    filePath: this.filePath,
                    ref: this.branch
                };
            },
            skip () {
                return !this.filePath;
            },
            error () {
                createAlert({
                    message: this.$options.i18n.errorMessage
                });
            }
        }
    },
    props: {
        projectPath: {
            type: String,
            required: true
        },
        filePath: {
            type: String,
            required: false,
            default: ''
        },
        branch: {
            type: String,
            required: false,
            default: ''
        },
        canViewBranchRules: {
            type: Boolean,
            required: false,
            default: false
        },
        branchRulesPath: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            isCodeOwnersExpanded: false,
            project: {}
        };
    },
    computed: {
        blobInfo () {
            return this.project?.repository?.blobs?.nodes[0];
        },
        collapseIcon () {
            return this.isCodeOwnersExpanded ? 'chevron-down' : 'chevron-right';
        },
        codeOwnersPath () {
            return this.project?.repository?.codeOwnersPath;
        },
        codeOwners () {
            return this.blobInfo?.codeOwners || [];
        },
        codeOwnersTotal () {
            return this.blobInfo?.codeOwners?.length;
        },
        toggleText () {
            return this.isCodeOwnersExpanded ? this.$options.i18n.hideAll : this.$options.i18n.showAll;
        },
        hasCodeOwners () {
            return this.filePath && Boolean(this.codeOwners.length);
        },
        codeOwnersSprintfMessage () {
            return toNounSeriesText(this.codeOwners.map((codeOwner, index)=>`%{linkStart}${index}%{linkEnd}`));
        },
        isLoading () {
            return this.$apollo.queries.project.loading;
        }
    },
    watch: {
        filePath () {
            this.$apollo.queries.project.refetch();
        }
    },
    methods: {
        toggleCodeOwners () {
            this.isCodeOwnersExpanded = !this.isCodeOwnersExpanded;
        },
        getCodeOwner (idx) {
            // what: idx could be a str coming from sprintf so we transform it to a number
            return this.codeOwners[Number(idx)];
        }
    }
};
